import React from 'react'
import { HelmetFunc } from 'components/PageMetaData'
import { CommercialProposalFormBlock } from 'blocks/CommercialProposalFormBlock'
import { RunningLine } from 'components/RunningLine'
import { useTranslation } from 'react-i18next'
import { Layout } from 'layout/Layout'
import { Faq } from 'blocks/FAQ/FAQ'
import { graphql } from 'gatsby'
import { imagesDataProp } from 'types/interfaces'

const pageMetadata = {
    uk: {
        title: 'Часті питання FAQ',
        description:
            'Короткі та швидкі відповіді на основні питання про дизайн інтер`єру, архітектрурне проектування, декорування від студії Clearline',
    },
    ru: {
        title: 'Часто задаваемые вопросы FAQ',
        description:
            'Короткие и быстрые ответы на основные вопросы о дизайне интерьера, архитектрурном проектировании, декорировании от студии Clearline',
    },
    en: {
        title: 'Frequently Asked Questions FAQ',
        description:
            'Short and quick answers to basic questions about interior design, architectural design, decoration from the Clearline studio',
    },
}

const ExamplePage = ({ data }: { data: imagesDataProp }) => {
    const { t } = useTranslation()
    return (
        <Layout>
            <HelmetFunc data={pageMetadata} />
            <Faq imagesData={data.allImageSharp} />
            <RunningLine>{t('designProject99')}</RunningLine>
            <CommercialProposalFormBlock text />
        </Layout>
    )
}

export default ExamplePage

export const query = graphql`
    query {
        allImageSharp: allFile(
            filter: {
                sourceInstanceName: { eq: "images" }
                extension: { in: ["jpg", "jpeg", "png", "webp"] }
            }
        ) {
            edges {
                node {
                    childImageSharp {
                        fluid(srcSetBreakpoints: [800]) {
                            originalName
                            ...GatsbyImageSharpFluid
                        }
                    }
                    parent {
                        ... on File {
                            name
                        }
                    }
                }
            }
        }
    }
`
